module.exports = __webpack_public_path__ + "Lato-Regular.7f690e503a254e0b8349";


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/assets/fonts/Lato/Lato-Regular.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-Regular.ttf
// module chunks = styles